export default {
  title: {
    en: 'Please edit your review',
  },

  titleLabel: {
    en: 'Title',
  },
  titlePlaceholder: {
    en: 'Review title',
  },
  reviewPlaceholder: {
    en: 'Review',
  },

  hint: {
    en: 'This optional information helps make your review more useful to other customers and receive a personalized recommendation.',
  },

  edit: {
    en: 'Edit review',
  },
  save: {
    en: 'Save review',
  },
}
